{register} = require 'src/js/infrastructure/setup-registry'

{MyRTKBaseMachinePathMapPlugin} = require 'src/coffee/areas/my-rtk-base/evaluation/plugins/machine-path-map-plugin'
{getByName} = require 'src/coffee/controls/map'
setup = ($ctx) ->
    map = getByName 'machine-activity', $ctx
    layerName = $('#layer-name').data 'layer-name-points'
    map.registerPlugin new MyRTKBaseMachinePathMapPlugin($ctx, layerName)

register 'App.MyRTKBase.Evaluation.MachineMapPathPlugin.Setup', setup